export class Payment {
  constructor(
    public readonly id: number,
    public readonly campaignId: number,
    public readonly amountInCents: string,
    public readonly createdAt: Date,
  ) {}
}
